// Currencies SafeGuest can run in. The property is charged in its own
// currency, so offering SafeGuest is a membership check.
// GBP, USD and AUD are always offered. EUR is behind `safeguest_eur`
// (UPL-9457).

const SAFEGUEST_CURRENCIES = ['GBP', 'USD', 'AUD'];
const SAFEGUEST_EUR_CURRENCIES = ['EUR'];

const UNSUPPORTED_CURRENCY_KEY =
  'automate_identity_and_deposits.safeguest.unsupported_currency';

const CURRENCY_RULE_TITLE_KEY = 'protection_settings.safeguest.rules.2.title';

export function supportedSafeguestCurrencies(eurEnabled: boolean): string[] {
  return [
    ...SAFEGUEST_CURRENCIES,
    ...(eurEnabled ? SAFEGUEST_EUR_CURRENCIES : []),
  ];
}

// The sentences that name the supported currencies stay as they are until EUR
// is switched on, then they name EUR as well.
export function safeguestUnsupportedCurrencyKey(eurEnabled: boolean): string {
  return eurEnabled
    ? `${UNSUPPORTED_CURRENCY_KEY}_eur`
    : UNSUPPORTED_CURRENCY_KEY;
}

export function safeguestCurrencyRuleTitleKey(eurEnabled: boolean): string {
  return eurEnabled
    ? `${CURRENCY_RULE_TITLE_KEY}_eur`
    : CURRENCY_RULE_TITLE_KEY;
}
